<template>
    <div class="home">
        <x-header >审计追踪</x-header>
        <x-content v-if="loading" style="height:100%;" :contentStyle="{alignItems:'center',justifyContent:'center',height:'100%'}">
            <bounce-loading></bounce-loading>
        </x-content>
        <x-content v-else  :contentStyle="{display:'block',width:'calc(100% - 32px)',padding:'16px'}">
            <div class="search_warp">
                <el-form label-width="70px" v-model="formItem">
                    <el-row class="list-control_warp" :gutter="10">
                        <el-col :span="5">
                            <el-form-item  label="研究人员">
                              <el-select  filterable   alwaysShowClear clearable v-model="formItem.userName" placeholder="请选择研究人员">
                                <el-option :value="item.id" :label="item.name" v-for="(item,index) in exUserList" :key="item.id"></el-option>
                              </el-select>
                           </el-form-item>
                        </el-col>
                       <el-col :span="5">
                           <el-form-item  label="实验名称">
							              <el-input  placeholder="请输入实验名称" alwaysShowClear clearable v-model="formItem.searchText" />
                           </el-form-item>
                        </el-col>
                        <el-col :span="5">
                           <el-form-item  label="实验编号">
							              <el-input  placeholder="请输入实验编号" alwaysShowClear clearable v-model="formItem.experimentId" />
                           </el-form-item>
                        </el-col>
                             <el-col :span="5">
                           <el-form-item  label="所属项目">
                              <el-select  filterable   alwaysShowClear clearable v-model="formItem.groupId" placeholder="请选择项目">
                                <el-option :value="item.id" :label="item.groupName" v-for="(item,index) in projectList" :key="item.id"></el-option>
                              </el-select>
                           </el-form-item>
                        </el-col>
                        <el-col :span="4"  >
                           <el-form-item  label="实验状态">
                            <el-select alwaysShowClear clearable v-model="formItem.status" style="width:100%;"  placeholder="请选择实验状态">
                              <el-option :value="item.value" :label="item.label" v-for="(item,index) in stateList" :key="index"></el-option>
                            </el-select>
                           </el-form-item>
                        </el-col>
                        <el-col  :md="9" :xl="7">
                           <el-form-item  label="创建时间">
							                  <el-date-picker style="border:1px solod"
                                v-model="formItem.createDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                                </el-date-picker>
                           </el-form-item>
                        </el-col>
                    <el-col :span="4">
                        <el-button   size="medium" type="primary"  @click="searchExperiment" icon="el-icon-search">
                             检索
                        </el-button>
                        <el-button   size="medium" type="info"  @click="clearSearch" icon="el-icon-refresh">
                            重置
                        </el-button>
                    </el-col>
                     <el-col :md="3" :xl="2">
                     
                        <el-button style="padding:11px;"  size="medium" class="btnInfo" @click="exportAudit" type="primary" icon="el-icon-tickets"> 生成审计报告</el-button>
                    </el-col>
                          <el-col :md="4" :xl="3">
                        <div class="sort_set" >
                          <el-select placeholder=""  v-model="sort" @change="searchExperiment"  style="width:50%;">
                            <el-option
                                v-for="item in sortOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                          </el-select>
                          <span style="cursor: pointer;margin-left:5px" @click="changeSortType" v-html="sortTypeHtml"></span>
                        </div>
                      </el-col>
                    </el-row>
                </el-form>
			      </div>
            <x-card>
                <el-table
                    :data="experimentList"
                    stripe
                    ref="auditExperiemnt"
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="experiment_id"
                        label="实验编号">
                        <template slot-scope="scope">
                              <el-tooltip content="查看实验详情" placement="bottom">
                            <el-link style='color:#409EFF' @click="$router.push('/manager/experiment/detail/'+scope.row.uuid+'/5')" :underline="false">{{scope.row.experiment_id}}</el-link>
                              </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="subject"
                        label="实验名称">
                    </el-table-column>
                    <el-table-column
                        label="所属项目">
                        <template slot-scope="scope">
                               <span class="">{{experimentGroupIdNameMap[scope.row.group_id]}}</span>
<!--                               <span class="">{{scope.row.group_id}}</span>-->
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="250"
                        label="属性">
                        <template slot-scope="scope">
                            <div style="display: flex; flex-direction: column;">
                                <span class="">创建时间：{{scope.row.create_time}}</span>
                                <span class="" v-if="scope.row.update_time">修改时间：{{scope.row.update_time}}</span>
                                <span class="">创建人：{{scope.row.user.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="100"
                        label="实验状态">
                        <template slot-scope="scope">
                            <span class="group_operate">{{scope.row.status=='0'?"待复核":scope.row.status=='1'?'复核通过':scope.row.status=='2'?'复核拒绝':scope.row.status=='3'?'待提交':scope.row.status=='4'?'已归档':''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                    v-if="!hasRole([SYSTEM_ROLE.MANAGER])"
                        width="170"
                        label="操作">
                        <template slot-scope="scope" >
<!--                          <action-panel :experimentObj="scope.row" :isOnlyCopy="true"></action-panel>-->
                          <el-button   size="mini" @click="$router.push('/manager/experiment/detail/'+scope.row.uuid+'/5')" type="success">查看 </el-button>
<!--                          <el-button   size="mini" @click="exportExcel(scope.row)"  class="btnInfo">导出 </el-button>-->
                          <el-button   size="mini" @click="nextListMark(scope.row)" type="primary">实验痕迹 </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-warp">
                    <el-pagination
                        @current-change="searchExperiment"
                        :hide-on-single-page="total<pageSize"
                        background
                        layout="total,prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page.sync="page"
                    ></el-pagination>
                </div>
            </x-card>
        </x-content>
      <app-dialog  ref="userSignatureDialog" dialogTitle="验证签名密码" originTitle staticDialog width="600px">
        <div>
          <el-form >
            <el-form-item  v-model="password">
              <el-input show-password v-model="password" placeholder="请输入签名密码"></el-input>
            </el-form-item>
            <div class="save_btn_warp">
              <el-button type="primary" @click="verify" style="width:200px;" size="medium" :loading="saveLoading">确定</el-button>
            </div>
          </el-form>
        </div>
      </app-dialog>
      <app-dialog ref="addDialog" dialogTitle="复核签名" originTitle staticDialog width="600px">
        <el-form :model="userSignature" ref="userSignatureForm" >
          <div style="display: flex;justify-content: center;">
            <vue-esign
                ref="esign"
                class="mySign"
                :width="600"
                :height="300"
                :isCrop="false"
                :lineWidth="6"
                lineColor="#000000"
                bgColor.sync="bgColor"
            />
          </div>
          <el-form-item >
            <el-input show-password v-model="userSignature.password" @clear="userSignature.password = ''" placeholder="请输入签名密码，密码格式为6位数字，下次输入密码即可完成电子签名"></el-input>
          </el-form-item>
        </el-form>
        <div class="save_btn_warp">
          <el-button type="warning" style="width:20%;" size="medium" @click="resetSign">清空签名</el-button>
          <el-button type="primary" style="width:20%;" size="medium" @click="saveSignImg">确定</el-button>
        </div>
      </app-dialog>
     <div>
         <ActionPanel ref="actionPanel" :experimentObj="experimentObj" style="display: none"></ActionPanel>
     </div>
    </div>
</template>
<script>
import {GetExUsers, GetMyProjectList} from "@/service/user"
import { ExportWordOrPdf, SearchExperiment} from "@/service/experiment";
import Form from '../../components/base/ui/form/Form.vue';
import {Verify, GetSignature, SignatureSave} from "@/service/userSignature";
  export default {
  components: { Form},
        name:'ExperimentSearch',
        data(){
            return {
                 saveLoading:false,
                loading:false,
                page:1,
                total:0,
                pageSize:10,
                experimentList:[],
                share:"0",
                groupId:"",
                formItem:{
                  searchText:'',
                  createDate:'',
                  experimentId:'',
                  groupId:'',
                  fullTextSearch:'',
                  status:'',
                  share:['1', '2'],
                  userName:'',
                },
                shareJson:'',
                experimentGroupIdNameMap:{},
                userIdNameMap:null,
                startDate:'',
                endDate:'',
                pickerOptions: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                },
                stateList:[
                    // {
                    //     label:'待提交',
                    //     value:'3'
                    // },
                        {
                        label:'待复核',
                        value:'0'
                    },    {
                        label:'复核通过',
                        value:'1'
                    },    {
                        label:'复核拒绝',
                        value:'2'
                    },
                  {
                    label:'已归档',
                    value:'4'
                  },
                ],
                sortOption: [{
                  value: 'create_time',
                  label: '创建时间'
                }, {
                  value: 'update_time',
                  label: '修改时间'
                }, {
                  value: 'experiment_id',
                  label: '实验编号'
                }],
                sortTypeHtml:'降序排序<i class="el-icon-sort-down"></i>',
                sortType:'desc',
                sort:'create_time',
                selectExperiment:[],
                exUserList:[],
                password:'',
              userSignature:{},
              projectList:[],
              experimentObj:{},
              listMarkShow:false,
            }
        },
        created(){
           this.searchExperiment();
           this.getMyProjectList();
           this.getExUsers();
        },
        methods:{
          changeSortType(){
            if(this.sortType=='desc'){
              this.sortType = 'asc';
              this.sortTypeHtml = '升序排序<i class="el-icon-sort-up"></i>'
              this.searchExperiment();
              return
            }
            if(this.sortType=='asc'){
              this.sortType = 'desc';
              this.sortTypeHtml = '降序排序<i class="el-icon-sort-down"></i>'
              this.searchExperiment();
              return
            }
          },
            clearSearch(){
              this.formItem.fullTextSearch='';
              this.formItem.searchText='';
              this.formItem.experimentId='';
              this.formItem.groupId='';
              this.formItem.status='';
              this.shareJson='';
              this.formItem.createDate='';
              this.formItem.userName='';
              this.formItem.share=['1', '2'];
              this.searchExperiment();
            },
            searchExperiment(){
                this.loading = true;
                if (this.formItem.createDate&&this.formItem.createDate.length>0){
                  this.startDate=this.formItem.createDate[0];
                  this.endDate=this.formItem.createDate[1];
                }else {
                  this.startDate='';
                  this.endDate='';
                }
                this.shareJson= this.formItem.share.join(',');
                SearchExperiment(
                    this.formItem.userName,
                    this.formItem.fullTextSearch,
                    this.formItem.searchText,
                    this.formItem.experimentId,
                    this.formItem.groupId,
                    this.formItem.status,
                    this.shareJson,
                    this.startDate,
                    this.endDate,
                    this.sort,
                    this.sortType,
                    this.page,
                    this.pageSize,
                  ).then(e => {
                    let data = this.APIParse(e);
                    this.experimentList = data?.hits.map(item => {
                      return item._source;
                    });
                    this.total = data.total || 0;
                  }).catch(e => {
                    this.$message.error(e.message)
                  }).finally(e => {
                    this.loading = false;
                  })

            },
            getMyProjectList(){
              GetMyProjectList().then(e => {
                let data = this.APIParse(e);
                this.projectList = data;
                data.forEach(item => {
                  this.$set(this.experimentGroupIdNameMap,item.id,item.groupName)
                })
                
              })
            },
            getExUsers(){
               GetExUsers().then(e => {
                let data = this.APIParse(e);
                this.exUserList = data;
              })
            },
           nextListMark(row){
             this.$nextTick(() => {
               this.listMarkShow=true
               this.experimentObj=row
               this.$refs.actionPanel.showListMark(row)
             })
             // this.listMark(row)
           },
          handleSelectionChange(val){
            this.selectExperiment = val;
          },
          exportWordOrPdf(type){
            type='pdf';
            this.$message.info("审计报告生成中")
            ExportWordOrPdf(this.selectExperiment.map(e => {return e.uuid}).join(","),type).then(e => {
              let data = this.APIParse(e);
              if(data.base64){
                this.$message.success("生成成功")
                this.downBlobToPage(data.base64,data.fileName)
                this.clearSelection();
              }
            }).catch(e => {
              this.$message.error("审计报告生成失败")
            })
          },
           clearSelection(){
            this.$refs.auditExperiemnt.clearSelection();
          },
          exportAudit(){
            if(this.selectExperiment.length==0){
              this.$message.warning("请选择要生成审计报告的实验！")
              return
            }
            GetSignature().then(e => {
                  if (e.data) {
                    this.userSignature = e.data;
                    this.signImg =  this.userSignature.signature;
                    this.$refs['userSignatureDialog'].show()
                  } else {
                    this.$refs['addDialog'].show()
                  }
                }
            ).catch(e => {
              this.$message.error(e.message)
            }).finally(e => {
            })
          },
          resetSign(){
            this.$refs.esign.reset();
          },
          saveSignImg(){
            if(!this.userSignature.password){
              this.$message({
                type: "warning",
                message: "请输入签名密码",
              });
              return
            }
            var patten =/^\d{6}$/;
            if (!patten.test(this.userSignature.password)) {
              this.$message("请输入正确的密码格式");
              return false;
            }
            this.$refs.esign
                .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
                .then((res) => {
                  // 构造 FormData，并将签名图片对象和签名密码作为字段传入
                  this.signImg = res;
                  this.userSignature.signature=res
                  if(!this.userSignature.signature){
                    this.$message({
                      type: "warning",
                      message: "您还没有签名",
                    });
                    return
                  }
                  SignatureSave(this.userSignature).then(e => {
                    if(e.code ==-1){
                      this.$message.error(e.msg)
                      return;
                    }
                    let data = this.APIParse(e)
                    this.exportWordOrPdf()
                    this.hideReview()
                  })
                })
                .catch((err) => {
                  // 画布没有签字时会执行这里提示一下
                  this.$message({
                    type: "warning",
                    message: "您还没有签名",
                  });
                });
          },
          hideReview(){
            this.$refs['userSignatureDialog'].hide()
            this.$refs['addDialog'].hide();
          },
          verify(){
            Verify(this.password).then(e => {
              let data = this.APIParse(e);
              if (data) {
                //this.$message.success("校验成功")
                this.$refs['userSignatureDialog'].hide()
                this.password=''
                this.exportWordOrPdf()
              }else{
                this.$message.error("签名密码输入错误，请检查")
                this.password='';
              }
            })
          },
        }
    }
</script>
<style lang="scss" scoped>
    .group_operate+.group_operate{
        margin-left: 15px;
    }
    .Width-100{width: 100%}
    .home{width: 100%;height: 100%;overflow: auto;}
    .search_warp{width:100%;margin: 16px 0px;}
</style>